const office = (docUrl: string) =>
    `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        docUrl
    )}`;
const google = (docUrl: string) =>
    `https://docs.google.com/viewer?url=${encodeURIComponent(
        docUrl
    )}&embedded=true`;

const officeTypes = [
    "application/msword",
    "application/vnd.ms-word.document.macroenabled.12",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "text/rtf",
];
const googleTypes = ["application/pdf"];

const officeExtensions = ["doc", "docx", "rtf"];
const googleExtensions = ["pdf"];

const isOfficeDoc = (type: string, extension?: string): boolean =>
    officeTypes.indexOf(type) >= 0 ||
    (!!extension && officeExtensions.indexOf(extension) >= 0);
const isGoogleDoc = (type: string, extension?: string): boolean =>
    googleTypes.indexOf(type) >= 0 ||
    (!!extension && googleExtensions.indexOf(extension) >= 0);

export const docViewerUrl = (
    url: string,
    type: string,
    extension?: string
): string => {
    if (isOfficeDoc(type, extension)) {
        return office(url);
    } else if (isGoogleDoc(type, extension)) {
        return google(url);
    }

    return url;
};
